import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CanDisable, mixinDisabled } from '@angular/material/core';
import { Observable, interval, tap } from 'rxjs';
import { ICuttingBaseMaterial } from '../../models/cutting/cutting-base-material.model';
import { CuttingButt } from '../../models/cutting/cutting-butt.model';
import { FacadeTextureDirectionEnum } from '../../models/cutting/cutting-facade.model';
import { Position } from '../../models/cutting/cutting-svg.model';
import { FacadeView } from '../../models/cutting/facade-view.model';
import { ApiLinks } from '../cutting-panel-list/csl.api-links';

export class PanelTextureSettingsBase {}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _PanelTextureSettingsMixinBase = mixinDisabled(PanelTextureSettingsBase);

@Component({
  selector: 'csl-panel-texture-settings',
  templateUrl: './panel-texture-settings.component.html',
  styleUrls: ['./panel-texture-settings.component.scss'],
  // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
  inputs: ['disabled'],
})
export class PanelTextureSettingsComponent extends _PanelTextureSettingsMixinBase implements CanDisable {
  outerMaterial: ICuttingBaseMaterial;
  upperMaterial: ICuttingBaseMaterial;

  materialUpdate$: Observable<number>;

  @Input() panel: FacadeView;
  @Input() userId: number;

  @Output() change: EventEmitter<{ changedDirectionPanel: FacadeView }> = new EventEmitter();

  constructor() {
    super();

    this.materialUpdate$ = interval(1000).pipe(
      tap(() => {
        this.outerMaterial = this.getOuterMaterial(this.panel);
        this.upperMaterial = this.getMainMaterial(this.panel);
      })
    );
  }

  isFilm = () => !!this.panel?.material?.film

  getOuterMaterial(panel: FacadeView): ICuttingBaseMaterial {
    if (panel?.material?.film) {
      return panel?.panelOutline?.filmMaterial;
    }

    return panel?.l1 || panel?.l2 || panel?.w1 || panel?.w2;
  }

  getMainMaterial(panel: FacadeView): ICuttingBaseMaterial {
    if (panel?.material?.film) {
      return panel?.panelOutline?.filmMaterial;
    }

    return panel?.material;
  }

  getPathToTexture(material: ICuttingBaseMaterial): string {
    if (!material) {
      return '';
    }

    return (
      material.cropTextureLink || `${ApiLinks.materialTexture}/${this.userId}/${material.textureName}`
    );
  }

  changeDirection(direction: FacadeTextureDirectionEnum): void {
    this.panel.textureDirection = direction;

    this.change.emit({ changedDirectionPanel: this.panel });
  }

  toggleEdge(enabled: boolean, side: Position): void {
    switch (side) {
      case 'tc':
        this.panel.l1 = enabled ? (this.outerMaterial as CuttingButt) : null;
        break;

      case 'bc':
        this.panel.l2 = enabled ? (this.outerMaterial as CuttingButt) : null;
        break;

      case 'lc':
        this.panel.w1 = enabled ? (this.outerMaterial as CuttingButt) : null;
        break;

      case 'rc':
        this.panel.w2 = enabled ? (this.outerMaterial as CuttingButt) : null;
        break;
    }
  }

  showColorMaterial(): boolean {
    if (this.panel.panelOutline.filmMaterial) {
      return !this.panel.panelOutline.filmMaterial?.textureName && !!this.panel.panelOutline.filmMaterial?.color;
    }

    return !this.panel?.material?.textureName && !!this.panel?.material?.color;
  }

  getColorMaterial(): { [key: string]: string } {
    return { ['background-color']: `#${this.panel?.panelOutline?.filmMaterial?.color || this.panel?.material?.color}` };
  }

  getTextureDirection(): { [key: string]: boolean } {
    return {
      ['vertical']:
        !!this.panel.panelOutline.filmMaterial || this.panel.textureDirection === FacadeTextureDirectionEnum.AlongWidth,
      ['horizontal']:
        !this.panel.panelOutline.filmMaterial && this.panel.textureDirection === FacadeTextureDirectionEnum.AlongHeight,
    };
  }
}
